import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { jobLabel, type FiveJobsRow } from '../zoom-setup-data';

/**
 * One setup's answer to the five jobs, as a table: job -> what does it here.
 * Rendered once per worked-example setup on the Zoom page and in the PDF.
 */
@Component({
  selector: 'app-five-jobs-table',
  templateUrl: './five-jobs-table.component.html',
  styleUrl: './five-jobs-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FiveJobsTableComponent {
  readonly caption = input.required<string>();
  readonly rows = input.required<readonly FiveJobsRow[]>();

  protected readonly label = jobLabel;
}
